import { FC } from 'react'
import { Typography, List } from '@mui/material'
import { FetchBillDetailsQuery } from '../../../../generated'
import { CardBox, CardBoxTopBar } from '../../../theme/styleComponents'
import BillClientMenuItem from './BillClientMenuItem'

interface BillClientsMenuProps {
  bill: FetchBillDetailsQuery['fetchBillDetails']['bill'] | undefined
  selectedClientId?: string | null
  onClientSelect: (clientId: string) => void
}

const BillClientMenu: FC<BillClientsMenuProps> = ({ bill, selectedClientId, onClientSelect }) => {
  if (!bill?.accessTokens?.length) {
    return null
  }

  return (
    <CardBox mb={3}>
      <CardBoxTopBar>
        <Typography variant="h6" fontWeight={400} color="gray900" fontSize="18px">
          Split Bill Clients
        </Typography>
      </CardBoxTopBar>

      <List sx={{ p: 0 }}>
        {bill.accessTokens?.map(accessToken => {
          return (
            <BillClientMenuItem
              key={accessToken.id}
              selectedClientId={selectedClientId}
              accessToken={accessToken}
              bill={bill}
              onClientSelect={onClientSelect}
            />
          )
        })}
      </List>
    </CardBox>
  )
}

export default BillClientMenu
